import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  GestureResponderEvent,
} from 'react-native';
import { Icon } from 'react-native-elements';
import { get } from 'lodash';
import { ServiceRequest } from '../../../store/appSlice';
import styles from '../styles';

interface Props {
  item: ServiceRequest;
  onPress: (item: ServiceRequest) => void;
}

const ProfileField = ({ item, onPress }: Props) => {
  const beatyDate = useMemo(() => {
    return moment(item.created_date).format('YYYY-MM-DD');
  }, [item]);

  const itemStatus = get(item, 'status.name', '');

  return (
    <TouchableOpacity onPress={() => onPress(item)}>
      <View style={styles.fieldContent}>
        <View style={styles.titleFieldWrapper}>
          <Text style={styles.titleContent}>
            {beatyDate} ({itemStatus})
          </Text>
          <Text style={styles.titleField}>{item.category.name}</Text>
        </View>

        <Icon
          style={styles.iconField}
          iconStyle={styles.iconFieldStyle}
          name="arrow-forward"
          size={26}
          tvParallaxProperties={null}
        />
      </View>
    </TouchableOpacity>
  );
};

export default React.memo(ProfileField);
